module.exports = __webpack_public_path__ + "assets/many1.1ee8bcbbe6d561f795851e6a6068212b.png";